const state = {
    showCartBox: false,
    showCartBag: true,
    carts: [],
    billingAddress: {},
};

const actions = {
    setShowCartBag({commit}, payload) {
        commit('SET_SHOW_CART_BAG', payload);
    },
    setShowCartBox({commit}, payload) {
        commit('SET_SHOW_CART_BOX', payload);
    },
    async getCarts({commit}) {
        commit('SET_LOADING', true, {root: true});
        window
            .axios
            .get('/api/carts')
            .then(response => {
                commit('SET_CARTS', response.data)
            })
            .finally(() => {
                commit('SET_LOADING', false, {root: true});
            });
    },
    async removeFromCart({commit, dispatch}, slug) {
        commit('SET_LOADING', true, {root: true});
        await window
            .axios
            .delete(`/api/carts/${slug}`)
        await dispatch('getCarts');
        commit('SET_LOADING', false, {root: true});
    },
    async updateCartQuantity({}, {slug, quantity}) {
        await window
            .axios
            .patch(`/api/carts/${slug}`, {quantity})
    },
    async placeOrder({commit, state}, payload) {
        commit('SET_LOADING', true, {root: true});
        commit('SET_ERRORS', {}, {root: true});
        commit('SET_SUCCESS', false, {root: true});

        await window
            .axios
            .patch(
                '/api/order/place',
                {
                    ...state.billingAddress,
                    ...payload,
                    district_id: state.billingAddress?.district?.code,
                    thana_id: state.billingAddress?.thana?.code,
                })
            .then(response => {
                commit('SET_SUCCESS', true, {root: true});
                commit('SET_RESPONSE', response.data, {root: true});
            }).catch(({response}) => {
                commit('SET_ERRORS', response.data.errors, {root: true});
                commit('SET_LOADING', false, {root: true});
                commit('SET_SUCCESS', false, {root: true});
            });
    },
}

const mutations = {
    SET_SHOW_CART_BAG(state, data) {
        state.showCartBag = data;
    },
    SET_SHOW_CART_BOX(state, data) {
        state.showCartBox = data;
    },
    SET_CARTS(state, data) {
        state.carts = data;
    },
    SET_BILLING_ADDRESS(state, data) {
        state.billingAddress = data;
    }
};

const getters = {
    total_price: state => {
        return state.carts.reduce((sum, cart) => {
            const price = Boolean(Number(cart.default_discount)) ?
                Number(cart.sell_price) - Number(cart.default_discount) :
                Number(cart.sell_price);

            return sum + (Number(cart.quantity) * price)
        }, 0);
    },
    totalQuantity: state => state.carts.reduce(
        (sum, cart) => sum + Number(cart.quantity),
        0
    ),
    isInCart: state => product => Boolean(state.carts.find(cart => Number(cart.id) === Number(product)))
}

export default {
    state,
    actions,
    mutations,
    getters,
}